module.exports = __webpack_public_path__ + "static/img/screenshots-ios@2x.9c3a99b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/images/screenshots-ios@2x.png
// module id = d5hg
// module chunks = 26